export default __webpack_public_path__ + "static/media/sprayzapp-home2.bff51e72.jpeg";